import { createAction, props } from '@ngrx/store';
import { IComplianceResponse, ISaveComplianceRequest, IUpdateComplianceRequest } from '../models/compliance.model';

export const loadComplianceRequest = createAction(
  '[Compliance] Load Compliance Request',
  props<{ customerId: string }>()
);

export const loadComplianceSuccess = createAction(
  '[Compliance] Load Compliance Success',
  props<{ response: IComplianceResponse[] }>()
);

export const loadComplianceFailure = createAction(
  '[Compliance] Load Compliance Failure',
  props<{ error: any }>()
);

export const addCompliance = createAction(
  '[KYC Documents] Add Compliance',
  props<{ request: ISaveComplianceRequest, customerId: string }>()
);

export const addComplianceSuccess = createAction(
  '[KYC Documents] Add Compliance Success',
  props<{ response: any }>()
);

export const addComplianceFailure = createAction(
  '[KYC Documents] Add Compliance Failure',
  props<{ error: any }>()
);

export const updateCompliance = createAction(
  '[KYC Documents] Update Compliance',
  props<{ request: IUpdateComplianceRequest, customerId: string, userProfileComplianceId: string }>()
);

export const updateComplianceSuccess = createAction(
  '[KYC Documents] Update Compliance Success',
  props<{ response: any }>()
);

export const updateComplianceFailure = createAction(
  '[KYC Documents] Update Compliance Failure',
  props<{ error: any }>()
);